import {ApiResource} from 'common/util/model-resource/api-resource';

import {tagsClient} from '../queries/app-api/tags';

export class TagsResource extends ApiResource<string> {
  apiClient = tagsClient;
}
